module.exports = __webpack_public_path__ + "static/media/banner2.baababe1.png";